import { Accordion } from "../global";
import { initSection } from "../utils";

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.body.dataset.suffix == "bundle-builder") {
    initSection("accordion-group", Accordion);
  }
});
